import { render, staticRenderFns } from "./szpc.vue?vue&type=template&id=860feb70&scoped=true&"
import script from "./szpc.vue?vue&type=script&lang=js&"
export * from "./szpc.vue?vue&type=script&lang=js&"
import style0 from "./szpc.vue?vue&type=style&index=0&id=860feb70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860feb70",
  null
  
)

export default component.exports